import axios from 'axios';

// Get the API URL from environment
const API = process.env.REACT_APP_BACKEND_URL || '';

// Create axios instance with credentials
const api = axios.create({
  baseURL: API,
  withCredentials: true, // Always include cookies
});

// Helper function to get CSRF token from cookie
const getCsrfToken = () => {
  const match = document.cookie.match(new RegExp('(^| )csrf_token=([^;]+)'));
  return match ? match[2] : null;
};

// Request interceptor to add CSRF token to state-changing requests
api.interceptors.request.use(
  (config) => {
    // Add CSRF token for state-changing methods
    if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
      const csrfToken = getCsrfToken();
      if (csrfToken) {
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized - redirect to login
    if (error.response?.status === 401) {
      // Only redirect if we're on an admin page
      if (window.location.pathname.startsWith('/admin') && 
          !window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    
    // Handle 403 Forbidden (CSRF error)
    if (error.response?.status === 403 && 
        error.response?.data?.detail?.includes('CSRF')) {
      console.error('CSRF token error. Please refresh the page and try again.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
export { getCsrfToken };
